<template lang="pug">
Fragment
  b-row
    b-col(cols='1')
      BackArrow
    b-col(cols='11').d-flex.justify-content-flex-start.mb-2
      h4.title Mantenedor de partes
  PartsList
</template>

<script>
import BackArrow from '../../components/UI/BackArrow.vue'
import PartsList from '../../components/Inventory/PartsList.vue'

export default {
  name: 'Parts',
  components: {
    BackArrow,
    PartsList,
  },
}
</script>

<style lang="scss" scoped>
.title {
  color: #74788d;
  font-weight: bold;
}
</style>
